// Filters out _id and _rev of PouchDB results and replaces '_id' with 'id'
export const filterAllDocsResult = (dbResult) => {
    const allDocs = dbResult.rows.map((x) => x.doc);
    const allDocsFiltered = allDocs.filter((x) => !`${x._id}`.startsWith('_design/idx'));
    return allDocsFiltered.map((x) => {
        x['id'] = x._id;
        delete x._id;
        delete x._rev;
        return x;
    });
};
